import React, { useState } from 'react'
import { Button, Popover, Tooltip } from 'antd'
import { FolderSymlink } from 'lucide-react'
import { GroupSelectorPopoverContent } from '../Groups/GroupSelectorPopoverContent'

interface Props {
  itemId: string
  currentGroupId?: string
}

export const GroupSelectionButton: React.FC<Props> = ({
  itemId,
  currentGroupId
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover
      content={
        <GroupSelectorPopoverContent
          entityId={itemId}
          parentGroupId={currentGroupId}
          entity="lineItem"
          onClose={() => setOpen(false)}
        />
      }
      destroyTooltipOnHide
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottom"
    >
      <Tooltip title="Move to Group">
        <Button
          type="text"
          icon={<FolderSymlink className="h-4 w-4" />}
          className="hover:text-primary"
        />
      </Tooltip>
    </Popover>
  )
}
